"use client";
import Features03Page from "@/components/tailwind/features";
import Features06Page from "@/components/tailwind/Features2";
import Footer04Page from "@/components/tailwind/Footerhome";
import { Navbar } from "@/components/tailwind/Navbarhome";
import Team01Page from "@/components/tailwind/Team";
import AnimatedGridPattern from "@/components/tailwind/ui/animated-grid-pattern";
import { Button } from "@/components/tailwind/ui/button";
import { SplashCursor } from "@/components/ui/splash-cursor";
import { cn } from "@/lib/utils";
import { ArrowUpRight, CircleDashed } from "lucide-react";

const Hero07 = () => {
  return (
    <div>
      <Navbar />
      <div className="relative min-h-screen flex items-center justify-center px-4 sm:px-8 overflow-hidden">
        <AnimatedGridPattern
          numSquares={50}
          maxOpacity={0.1}
          duration={3}
          repeatDelay={1}
          className={cn(
            "inset-x-0 h-full skew-y-12",
            "sm:[mask-image:radial-gradient(600px_circle_at_center,white,transparent)]",
            "lg:[mask-image:radial-gradient(800px_circle_at_center,white,transparent)]"
          )}
        />
        <div className="relative z-10 text-center max-w-5xl px-4">
          🚀 Just launched v1.0.0
          <h1 className="mt-6 text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black leading-[1.1] tracking-tighter">
            Build Beautiful Documentation <br className="hidden sm:block" /> in Minutes
          </h1>
          <p className="mt-6 text-lg sm:text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto">
            Docloo is the ultimate platform for creating, managing, and sharing stunning documentation.
            Whether you're a developer, team, or startup, Docloo simplifies your workflow with intuitive tools and customizable templates.
          </p>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-4 sm:gap-6">
            <Button
            // navigate to dashboard
              onClick={() => window.location.href = "/dashboard"}
             size="default" className="rounded-full text-lg h-14 px-8">
              Start Building <ArrowUpRight className="!h-6 !w-6 ml-2" />
            </Button>
            <Button
              variant="outline"
              size="default"
              className="rounded-full text-lg h-14 px-8 shadow-none hover:bg-primary/10"
            >
              <CircleDashed className="!h-6 !w-6 mr-2" /> Watch Demo
            </Button>
          </div>
        </div>
       
      </div>
      <div className="mt-12 sm:mt-24 w-full flex justify-center">
          <Features03Page />
        </div>
        {/* <SplashCursor /> */}
      <Features06Page />
      {/* <Team01Page /> */}
      <Footer04Page />
     
    </div>
  );
};

export default Hero07;
